import React, { lazy } from 'react'
import MapPageLazyLoadWrapper from 'map/MapPageLazyLoadWrapper/MapPageLazyLoadWrapper'

const MapPage = lazy(() => {
  return import('./MapPage')
})

const SiteProposalMapPageWrapper = () => {
  return <MapPageLazyLoadWrapper footerHeight={0} headerHeight={0} sidebarWidth={300}><MapPage /></MapPageLazyLoadWrapper>
}

export default SiteProposalMapPageWrapper
